"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwapContextBoundary = void 0;
var react_provision_1 = require("@newfront-insurance/react-provision");
var react_1 = __importDefault(require("react"));
/**
 * Everything within this boundary will only be rendered if the user has completed the auth flow.
 */
function SwapContextBoundary(props) {
    var fallback = props.fallback, children = props.children, authProvider = props.authProvider;
    var _a = (0, react_provision_1.useProvider)(authProvider), swapContext = _a.swapContext, scopes = _a.scopes;
    if (!swapContext || !scopes) {
        return fallback ? react_1.default.createElement(react_1.default.Fragment, null, fallback) : null;
    }
    return react_1.default.createElement(react_1.default.Fragment, null, children);
}
exports.SwapContextBoundary = SwapContextBoundary;
